import {
  calculateRiskScore,
  recalculateAnalysisMetrics,
} from "@/utils/risk-calculator";
import type {
  AttackCategoryData,
  ImpactLevel,
  OrganizationSize,
  ProbabilityLevel,
  SectorAnalysis,
} from "@/types/risk-analysis";

export function applyProbabilityChange(
  attackMatrix: AttackCategoryData[],
  categoryId: string,
  actorId: string,
  probability: ProbabilityLevel,
  orgSize: OrganizationSize
): AttackCategoryData[] {
  return attackMatrix.map((category) => {
    if (category.categoryId !== categoryId) return category;

    const updatedActors = { ...category.actors };
    updatedActors[actorId] = {
      probability,
      score: calculateRiskScore({
        probability,
        impact: category.impact,
        attackType: category.tipAtac,
        orgSize,
      }),
    };

    return { ...category, actors: updatedActors };
  });
}

export function applyImpactChange(
  attackMatrix: AttackCategoryData[],
  categoryId: string,
  impact: ImpactLevel,
  orgSize: OrganizationSize
): AttackCategoryData[] {
  return attackMatrix.map((category) => {
    if (category.categoryId !== categoryId) return category;

    const updatedActors = Object.fromEntries(
      Object.entries(category.actors).map(([actorId, actorData]) => [
        actorId,
        {
          ...actorData,
          score: calculateRiskScore({
            probability: actorData.probability,
            impact,
            attackType: category.tipAtac,
            orgSize,
          }),
        },
      ])
    );

    return { ...category, impact, actors: updatedActors };
  });
}

export function buildUpdatedAnalysis(
  analysis: SectorAnalysis,
  updatedMatrix: AttackCategoryData[]
): SectorAnalysis {
  const { actorTotals, totalScore, cyfunLevel } =
    recalculateAnalysisMetrics(updatedMatrix);

  return {
    ...analysis,
    attackMatrix: updatedMatrix,
    actorTotals,
    totalScore,
    cyfunLevel,
  };
}
